import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum AnalyticsTemplateLibraryPermissionSet {
  View = 'analytics_template_library_view',
  Write = 'analytics_template_library_write',
  Archive = 'analytics_template_library_archive',
  Delete = 'analytics_template_library_delete',
}

export const analyticsTemplateLibraryPermissionSetGrouping: IPermissionSetGrouping<AnalyticsTemplateLibraryPermissionSet> =
  {
    key: PermissionSetGroupingKey.AnalyticsTemplateLibrary,
    active: {
      [AnalyticsTemplateLibraryPermissionSet.View]: [
        PermissionType.GET_ANY_TEMPLATE_REPORT,
        PermissionType.GET_ANY_TEMPLATE_DASHBOARD,
      ],
      [AnalyticsTemplateLibraryPermissionSet.Write]: [
        PermissionType.POST_ANY_TEMPLATE_REPORT,
        PermissionType.PATCH_ANY_TEMPLATE_REPORT,
        PermissionType.POST_ANY_TEMPLATE_DASHBOARD,
        PermissionType.PATCH_ANY_TEMPLATE_DASHBOARD,
      ],
      [AnalyticsTemplateLibraryPermissionSet.Archive]: [
        PermissionType.ARCHIVE_ANY_TEMPLATE_REPORT,
        PermissionType.ARCHIVE_ANY_TEMPLATE_DASHBOARD,
      ],
      [AnalyticsTemplateLibraryPermissionSet.Delete]: [
        PermissionType.DELETE_ANY_TEMPLATE_REPORT,
        PermissionType.DELETE_ANY_TEMPLATE_DASHBOARD,
      ],
    },
    unAssignablePermissionSets: [
      AnalyticsTemplateLibraryPermissionSet.View,
      AnalyticsTemplateLibraryPermissionSet.Write,
      AnalyticsTemplateLibraryPermissionSet.Archive,
      AnalyticsTemplateLibraryPermissionSet.Delete,
    ],
  }
